const slider = document.querySelector('.custom-slider');
const leftHandle = document.querySelector('.left-handle');
const rightHandle = document.querySelector('.right-handle');

const slides = document.querySelectorAll('.custom-slider a');
let itemPerSlide = 4;

slides.forEach((slide) => {
	let computedStyle = window.getComputedStyle(slide);
	itemPerSlide = computedStyle.getPropertyValue('--item-per-slide');
});

const slideWidth = 100 / itemPerSlide;

const logoSliderId = setInterval(slideRight, 6000);

leftHandle.addEventListener('click', () => {
	// Stop slider
	clearInterval(logoSliderId);
	slideLeft();
});

rightHandle.addEventListener('click', () => {
	// Stop slider
	clearInterval(logoSliderId);

	slideRight();
});

function slideLeft() {
	// Get current slides
	const slides = document.querySelectorAll('.custom-slider a');
	const lastPart = [...slides].slice(-itemPerSlide).reverse();

	// Clone last 4 elements
	lastPart.forEach((el) => {
		const clone = el.cloneNode(true);
		slider.prepend(clone);
	});

	slider.style.setProperty(
		'transform',
		`translateX(${-slideWidth * itemPerSlide}%)`
	);

	setTimeout(() => {
		// Move slider
		slider.style.setProperty('transition', `transform 0.6s ease-in-out`);
		slider.style.setProperty('transform', `translateX(${0}%)`);
	}, 350);

	// Reset and remove last 4 elements
	setTimeout(() => {
		// Default position
		slider.style.setProperty('transition', `transform 0s ease-in-out`);
		slider.style.setProperty('transform', `translateX(${0}%)`);
		for (let i = 0; i < itemPerSlide; i++) {
			slider.removeChild(slider.lastElementChild);
		}
	}, 450);
}

function slideRight() {
	// Get current slides
	const slides = document.querySelectorAll('.custom-slider a');
	const firstPart = [...slides].slice(0, itemPerSlide);

	// Clone first 4 elements
	firstPart.forEach((el) => {
		const clone = el.cloneNode(true);
		slider.appendChild(clone);
	});

	// Move slider
	slider.style.setProperty('transition', `transform 1.05s ease-in-out`);
	slider.style.setProperty(
		'transform',
		`translateX(${-slideWidth * itemPerSlide}%)`
	);

	// Reset and remove first 4 elements
	setTimeout(() => {
		// Default position
		slider.style.setProperty('transition', `transform 0s ease-in-out`);
		slider.style.setProperty('transform', `translateX(${0}%)`);
		for (let i = 0; i < itemPerSlide; i++) {
			slider.removeChild(slider.firstElementChild);
		}
	}, 550);
}
